import { render } from "./ContactMe.vue?vue&type=template&id=563e4eaf&scoped=true"
import script from "./ContactMe.vue?vue&type=script&lang=js"
export * from "./ContactMe.vue?vue&type=script&lang=js"

import "./ContactMe.vue?vue&type=style&index=0&id=563e4eaf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-563e4eaf"

export default script